import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "actions", "count", "total", "form"]
  static values = { pricePerItem: Number }

  connect() {
    this.updateUI()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(checkbox => {
      // Only toggle visible checkboxes (not hidden by filters)
      const row = checkbox.closest("[data-bulk-item]")
      if (!row || !row.classList.contains("hidden")) {
        checkbox.checked = checked
      }
    })
    this.updateUI()
  }

  toggle() {
    this.updateUI()
  }

  updateCount() {
    this.updateUI()
  }

  updateUI() {
    const visibleCheckboxes = this.checkboxTargets.filter(checkbox => {
      const row = checkbox.closest("[data-bulk-item]")
      return !row || !row.classList.contains("hidden")
    })

    const checkedCount = visibleCheckboxes.filter(cb => cb.checked).length
    const totalCount = visibleCheckboxes.length

    // Update select all checkbox state
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = checkedCount === totalCount && totalCount > 0
      this.selectAllTarget.indeterminate = checkedCount > 0 && checkedCount < totalCount
    }

    // Show/hide bulk actions
    if (this.hasActionsTarget) {
      if (checkedCount > 0) {
        this.actionsTarget.classList.remove("hidden")
      } else {
        this.actionsTarget.classList.add("hidden")
      }
    }

    // Update all count displays (use countTargets plural to get all)
    this.countTargets.forEach(el => {
      el.textContent = checkedCount
    })

    // Update total price if we have a price and total target
    if (this.hasTotalTarget && this.hasPricePerItemValue) {
      const totalPrice = (checkedCount * this.pricePerItemValue).toFixed(2)
      this.totalTargets.forEach(el => {
        el.textContent = totalPrice
      })
    }
  }

  getSelectedIds() {
    return this.checkboxTargets
      .filter(cb => cb.checked)
      .map(cb => cb.value)
  }

  clearSelection() {
    this.checkboxTargets.forEach(cb => cb.checked = false)
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = false
      this.selectAllTarget.indeterminate = false
    }
    this.updateUI()
  }

  confirmBulkAction(event) {
    const selectedIds = this.getSelectedIds()
    const count = selectedIds.length

    if (count === 0) {
      event.preventDefault()
      // Use toast notification instead of disruptive alert dialog
      if (typeof window.showToast === "function") {
        window.showToast("Please select at least one item first.", "warning")
      }
      return
    }

    const action = event.currentTarget.dataset.bulkAction || "perform this action on"
    const isDestructive = event.currentTarget.dataset.bulkDestructive === "true"
    let confirmMessage = event.currentTarget.dataset.bulkConfirm ||
      `${action} ${count} guest${count === 1 ? '' : 's'}?`

    // Replace {count} placeholder with actual count
    confirmMessage = confirmMessage.replace("{count}", count)

    // For destructive actions with many items, require more explicit confirmation
    if (isDestructive && count >= 5) {
      confirmMessage = `WARNING: You are about to permanently delete ${count} item${count === 1 ? '' : 's'}.\n\nThis action cannot be undone.\n\nAre you absolutely sure?`
    }

    if (!confirm(confirmMessage)) {
      event.preventDefault()
      return
    }

    // Add selected IDs to the form
    const form = event.currentTarget.closest("form") ||
      (this.hasFormTarget ? this.formTarget : null)

    if (form) {
      this.addSelectedIdsToForm(form, selectedIds)
    }
  }

  addSelectedIdsToForm(form, selectedIds) {
    // Remove existing hidden inputs
    form.querySelectorAll('input[name="invitation_ids[]"]').forEach(el => el.remove())

    // Add new hidden inputs for each selected ID
    selectedIds.forEach(id => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'invitation_ids[]'
      input.value = id
      form.appendChild(input)
    })
  }
}
